import { render, staticRenderFns } from "./DraggableFieldChip.vue?vue&type=template&id=6395f793&scoped=true"
import script from "./DraggableFieldChip.vue?vue&type=script&lang=js"
export * from "./DraggableFieldChip.vue?vue&type=script&lang=js"
import style0 from "./DraggableFieldChip.vue?vue&type=style&index=0&id=6395f793&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6395f793",
  null
  
)

export default component.exports